import Swal from 'sweetalert2';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";


export default {
  name: 'ThankYouPage',
  mixins: [LOGOUT, MAIN_CONTROLLER],
  data() {
    return {
      workflows: []
    };
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.check_complete_notification();
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    }
  },
  methods: {
    check_complete_notification() {
      const token = localStorage.getItem('token');
      const base_url = API_BASE_URL;
      const check_complete_url = `${base_url}/verify_api/workflow_management_api/check_workflow_complete_notification_api/${this.workflow_id}`;

      fetch(check_complete_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${token}`
        }
      });
    },
    client_application_sub_workflow(workflow) {
      if (workflow.sub_workflow_type == 'internal') {
        const token = localStorage.getItem('token');
        const base_url = API_BASE_URL;

        const get_customer_application_url = `${base_url}/verify_api/service_management_api/create_sub_workflow_application/`;
        $.ajax({
          method: 'POST',
          url: get_customer_application_url,
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${token}`
          },
          data: JSON.stringify({ workflow_id: workflow.workflow_id }),
          beforeSend: () => {
            Swal.fire({
              text: 'Loading ...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              }
            })
          },
          success: (response) => {
            Swal.close();
            if (response.status === 'success') {
              this.$store.dispatch('update_workflow_id', workflow.workflow_id);
              this.fetch_current_service();
            }
          },
          error: (xhr) => {
            Swal.close();

            const error_msg = xhr.responseJSON?.message || 'Failed to continue with application.';
            Swal.fire({
              icon: 'error',
              title: 'System Error',
              text: error_msg,
              timer: 3000,
              timerProgressBar: true,
              showConfirmButton: false
            });
          }
        });
      }
      else {
        window.open(workflow.external_url, '_blank');
      }
    },

    redirect_to_dashboard() {
      this.logout();
    }
  },
};
